(() => {
  'use strict';
  // Shared DAYLO interactions: flip-the-bottle cards, add-a-routine (several items in one request) and the welcome-code copy button.
  if (window.DayloCart) return;
  const root = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

  const showError = (trigger, message) => {
    const host = trigger?.closest('[data-dl-buy]') || trigger?.parentElement;
    if (!host) return;
    let note = host.querySelector('[data-dl-error]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'dl-error';
      note.dataset.dlError = '';
      note.setAttribute('role', 'alert');
      host.append(note);
    }
    note.textContent = message;
    note.hidden = !message;
  };

  async function addItems(items, trigger) {
    if (!Array.isArray(items) || !items.length) return false;
    if (trigger) { trigger.disabled = true; trigger.setAttribute('aria-busy', 'true'); }
    showError(trigger, '');
    try {
      const response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(typeof body.description === 'string' ? body.description : 'These items could not be added. Please try again.');
      const opener = document.querySelector('.header [data-open-cart], [data-open-cart]');
      if (opener) opener.click();
      else window.location.assign(`${root()}cart`);
      return true;
    } catch (error) {
      showError(trigger, error.message);
      return false;
    } finally {
      if (trigger) { trigger.disabled = false; trigger.removeAttribute('aria-busy'); }
    }
  }
  window.DayloCart = { addItems };

  // Supplement Facts images on product cards load only when a shopper reaches for them.
  const hydrateLabel = art => {
    const img = art && art.querySelector('img[data-dl-src]');
    if (!img) return;
    img.src = img.dataset.dlSrc;
    img.removeAttribute('data-dl-src');
  };
  const onIntent = event => {
    const flip = event.target.closest && event.target.closest('[data-dl-flip]');
    if (flip) hydrateLabel(flip.closest('.dl-art'));
  };
  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
  document.addEventListener('touchstart', onIntent, { passive: true });

  document.addEventListener('click', event => {
    const flip = event.target.closest('[data-dl-flip]');
    if (flip) {
      const art = flip.closest('.dl-art');
      if (!art) return;
      hydrateLabel(art);
      const on = !art.classList.contains('is-flipped');
      art.classList.toggle('is-flipped', on);
      flip.setAttribute('aria-pressed', String(on));
      const label = flip.querySelector('[data-dl-flip-label]');
      if (label) label.textContent = on ? flip.dataset.front : flip.dataset.back;
      const back = art.querySelector('.dl-back');
      if (back) back.setAttribute('aria-hidden', String(!on));
      return;
    }
    const routine = event.target.closest('[data-dl-routine-add]');
    if (routine) {
      event.preventDefault();
      let items = [];
      try { items = JSON.parse(routine.dataset.items || '[]'); } catch (_) { items = []; }
      void addItems(items, routine);
      return;
    }
    const copy = event.target.closest('[data-dl-copy]');
    if (copy) {
      const code = copy.dataset.dlCopy;
      const done = () => { copy.textContent = copy.dataset.done || 'Copied'; };
      if (navigator.clipboard?.writeText) navigator.clipboard.writeText(code).then(done).catch(() => {});
    }
  });
})();
